export const stepsDesktop = [
  {
    element: "#profile-driver-js",
    popover: {
      title: "Alternar Empresas",
      description: `Gerencie múltiplas empresas com facilidade! Clique aqui para alternar entre suas empresas cadastradas 
        e acessar seus planejamentos financeiros.`,
      side: "right",
      align: "start",
    },
  },
  {
    element: "#novo-planejamento-driver-js",
    popover: {
      title: "Novo Planejamento",
      description: `Inicie um planejamento financeiro estratégico! Registre entradas, custos e investimentos para visualizar sua
        projeção e tomar decisões mais seguras.`,
      side: "left",
      align: "start",
    },
  },
  {
    element: "#meus-planejamentos-driver-js",
    popover: {
      title: "Meus Planejamentos",
      description: `Acompanhe seus planejamentos financeiros de forma organizada. Edite, visualize e recupere dados sempre que precisar!`,
      side: "left",
      align: "start",
    },
  },
  {
    element: "#info-driver-js",
    popover: {
      title: "Informações da conta",
      description: `Aqui você encontra todas as informações essenciais do seu perfil e das suas empresas cadastradas.
        Mantenha seus dados sempre atualizados`,
      side: "left",
      align: "start",
    },
  },
  {
    element: "#pill-planning-right-driver-js",
    popover: {
      title: "Pílulas de Conhecimento",
      description: `Acesse conteúdos atualizados e relevantes para o seu negócio! Confira insights e dicas estratégicas
      para aprimorar sua gestão financeira e impulsionar seus resultados.`,
      side: "left",
      align: "start",
    },
  },
];

export const stepsMobile = [
  {
    element: "#profile-driver-js",
    popover: {
      title: "Alternar Empresas",
      description: `Gerencie múltiplas empresas com facilidade! Clique aqui para alternar entre suas empresas cadastradas 
        e acessar seus planejamentos financeiros.`,
      side: "right",
      align: "center",
    },
    onHighlighted: () => {
      const sideBar = document.querySelector(".list-menu");
      if (sideBar) {
        sideBar.classList.remove("open");
      }
    },
  },
  {
    element: "#home-2-driver-js",
    popover: {
      title: "Novo Planejamento",
      description: `Inicie um planejamento financeiro estratégico! Registre entradas, custos e investimentos para visualizar sua
        projeção e tomar decisões mais seguras.`,
      side: "bottom",
      align: "center",
    },
    onHighlighted: () => {
      const sideBar = document.querySelector(".list-menu");
      if (sideBar) {
        sideBar.classList.add("open");
      }
    },
  },
  {
    element: "#home-3-driver-js",
    popover: {
      title: "Meus Planejamentos",
      description: `Acompanhe seus planejamentos financeiros de forma organizada. Edite, visualize e recupere dados sempre que precisar!`,
      side: "left",
      align: "center",
    },
    onHighlighted: () => {
      const sideBar = document.querySelector(".list-menu");
      if (sideBar) {
        sideBar.classList.add("open");
      }
    },
  },
  {
    element: "#profile-open-driver-js",
    popover: {
      title: "Informações da conta",
      description: `Aqui você encontra todas as informações essenciais do seu perfil e das suas empresas cadastradas.
        Mantenha seus dados sempre atualizados`,
      side: "left",
      align: "center",
    },
    onHighlighted: () => {
      const sideBar = document.querySelector(".list-menu");
      if (sideBar) {
        sideBar.classList.add("open");
      }
    },
  },
  {
    element: "#pill-planning-right-driver-js",
    popover: {
      title: "Pílulas de Conhecimento",
      description: `Acesse conteúdos atualizados e relevantes para o seu negócio! Confira insights e dicas estratégicas
      para aprimorar sua gestão financeira e impulsionar seus resultados.`,
      side: "top",
      align: "start",
    },
    onHighlighted: () => {
      const sideBar = document.querySelector(".list-menu");
      if (sideBar) {
        sideBar.classList.remove("open");
      }
    },
  },
];
